import { FC, RefObject, useEffect, useRef, useState } from "react";
import { Attendes, EventData } from "../../interfaces/EventData";
import moment from "moment";
import { KTSVG } from "../../_metronic/helpers";
import { UpdateEvent } from "./UpdateEvent";
import { Modal } from "bootstrap";
import FullCalendar from "@fullcalendar/react";
import { DeleteEvent } from "./DeleteEvent";
import useSWR from "swr";
import axios from "axios";
import useAccessToken from "../../hooks/AccessToken";
import { EventImpl } from "@fullcalendar/core/internal";
import Swal from "sweetalert2";
import { updateEvent } from "../../api/EventCRUD";
import { invitationResponse } from "../../api/CalendarCRUD";
import { Message, toaster } from "rsuite";
import { useSettingsStore } from "../../stores/SettingsStore";
import { truncateText } from "../../functions/general";
import { useIntl } from "react-intl";
import { Meeting, Pipeline } from "../../interfaces";
import { getDetailMeeting } from "../../api/MeetingsCRUD";
import { getDetailPipeline } from "../../api/PipelineCRUD";
import useModalEffect from "../../hooks/useModalEffect";
import { usePipelineStore } from "../../stores/PipelineStore";
import { useMeetingStore } from "../../stores/MeetingsStore";

interface eventProps {
    id: string,
    events: []
}

interface Props {
    eventData: EventImpl
    calendarRef: RefObject<FullCalendar>
    calendar: any
    selectedCalendars: string[]
    listEvent: eventProps[]
    setListEvent: React.Dispatch<React.SetStateAction<eventProps[]>>
    setDataMeeting: React.Dispatch<React.SetStateAction<Meeting>>
    setDataPipeline: React.Dispatch<React.SetStateAction<Pipeline>>
    setShowDetailMeetingModal: React.Dispatch<React.SetStateAction<boolean>>
    setShowDetailPipelineModal: React.Dispatch<React.SetStateAction<boolean>>
}

const DetailEvent: FC<Props> = ({ eventData, calendarRef, calendar, listEvent, setListEvent, selectedCalendars, setDataMeeting, setDataPipeline, setShowDetailMeetingModal, setShowDetailPipelineModal }) => {
    const { settings } = useSettingsStore()
    const { multiPipelines, setSelectMultiPipeline } = usePipelineStore()
    const { multiMeetings, setSelectMultiMeeting } = useMeetingStore()
    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [event, setEvent] = useState<EventData>();
    const [accessEvent, setAccessEvent] = useState<string>("");
    const modalRef = useRef<HTMLDivElement | null>(null);
    const closeModalRef = useRef<HTMLDivElement>(null);
    const API_URL = process.env.REACT_APP_API_URL
    const token = useAccessToken()
    const intl = useIntl()

    const fetcher = (url: string) => {
        return axios.get(url, {
            headers: {
                'X-Auth-token': token
            },
        }).then(res => res.data.data);
    }

    const { data: eventDetail, error: eventDetailError, isValidating: eventDetailValidating } = useSWR(`${API_URL}calendars/${eventData.extendedProps.calendar.id}/events/${eventData.id}`, fetcher, { revalidateOnFocus: false, revalidateOnReconnect: false })

    useModalEffect({
        showModal: showUpdateModal,
        setShowModal: setShowUpdateModal,
        modalId: 'update-event-modal'
    })

    useModalEffect({
        showModal: showDeleteModal,
        setShowModal: setShowDeleteModal,
        modalId: 'delete-event-modal'
    })

    useEffect(() => {
        if (!eventDetailValidating) {
            const dataDetail = {
                ...eventDetail,
                allAttendance: [...eventDetail.attendees, ...eventDetail.merchantAttendees],
            };
            setEvent(dataDetail)
            var dataEvent = calendar.find((data: EventData) => data.id === eventDetail?.calendar.id);
            setAccessEvent(dataEvent?.access)
        }
    }, [eventDetail]);

    const handleDeleteEvent = (data: EventData) => {
        Swal.fire({
            title: intl.formatMessage({ id: 'FORM.VALIDATION.NOTIFICATION' }),
            html: intl.formatMessage({ id: 'FORM.VALIDATION.SEND_CANCEL_NOTIFICATION' }),
            icon: "question",
            showCancelButton: true,
            showDenyButton: true,
            buttonsStyling: false,
            confirmButtonText: intl.formatMessage({ id: 'FORM.ACTION.SEND_NOTIFICATION' }),
            denyButtonText: intl.formatMessage({ id: 'FORM.ACTION.DONT_SEND_NOTIFICATION' }),
            cancelButtonText: intl.formatMessage({ id: 'FORM.ACTION.CANCEL' }),
            customClass: {
                confirmButton: "btn btn-active-color-primary",
                denyButton: "btn btn-active-color-gray-400",
                cancelButton: "btn btn-active-color-gray-400",
            },
            reverseButtons: true,
            heightAuto: false,
            target: document.getElementById('detail-event-modal'),
        }).then(async (result) => {
            var notification = false

            if (result.isConfirmed) {
                notification = true
            } else if (result.isDenied) {
                notification = false
            }

            if (!result.isDismissed) {
                try {
                    const response = await updateEvent({
                        name: data.title,
                        description: data.description,
                        type: data.type,
                        timezone: data.timezone,
                        status: 'CANCELLED',
                        isAllDay: data.allDay,
                        start: {
                            date: data.allDay ? moment(data.start).format("YYYY-MM-DD") : null,
                            dateTime: !data.allDay ? moment(data.start).toISOString(true) : null
                        },
                        end: {
                            date: data.allDay ? moment(data.end).format("YYYY-MM-DD") : null,
                            dateTime: !data.allDay ? moment(data.end).toISOString(true) : null
                        },
                        color: data.color,
                        reminderMinutes: data.reminderMinutes === 0 ? 1 : data.reminderMinutes,
                        location: data.location,
                        idCalendar: data.calendar.id,
                        idEvent: data.id,
                        sendNotification: notification,
                        onlineMeetLink: data.onlineMeetLink ?? null,
                        token: token,
                    })
                    if (response.data.success || response.status === 201) {
                        Swal.fire({
                            icon: "success",
                            title: intl.formatMessage({ id: 'ALERT.TITLE.SUCCESS' }),
                            text: intl.formatMessage({ id: 'FORM.VALIDATION.DELETE_SUCCESS' }),
                            heightAuto: false,
                        })

                        const updatedListEvent = listEvent.map((eventItem: eventProps) => {
                            const hasSameId = eventItem.events.some((e: any) => e.id === eventData.id);

                            if (hasSameId) {
                                return {
                                    ...eventItem,
                                    events: eventItem.events.filter((e: any) => e.id !== eventData.id)
                                };
                            }
                            return eventItem;
                        });

                        setListEvent(updatedListEvent as eventProps[]);
                        calendarRef.current?.getApi().getEventById(eventData.id)?.remove()
                        closeModalRef.current?.click();
                        modalRef.current?.click();
                    }
                } catch (error: any) {
                    Swal.fire({
                        icon: 'error',
                        title: error.response.data.message,
                        confirmButtonText: 'Ok'
                    })
                }
            }
        })
    }

    const handleInvite = async (val: string) => {
        try {
            const response = await invitationResponse(eventData.extendedProps.calendar.id, eventData.id, val, token);
            if (response.data.success) {
                Swal.fire({
                    icon: "success",
                    title: intl.formatMessage({ id: 'ALERT.TITLE.SUCCESS' }),
                    text: intl.formatMessage({ id: 'FORM.VALIDATION.SAVE_SUCCESS' }),
                    heightAuto: false,
                })
                var dataEvent = { ...event, response: val }
                setEvent(dataEvent as EventData)
                closeModalRef.current?.click();
            }
        } catch (error: any) {
            Swal.fire({
                target: document.getElementById('detail-event-modal'),
                icon: 'error',
                title: error.response.data.message,
                confirmButtonText: 'Ok',
                heightAuto: false,
            })
        }
    }

    const handleClickDetailMeeting = async () => {
        if (event?.meeting) {
            try {
                const response = await getDetailMeeting(event.meeting.id, token)
                if (response.data.success) {
                    closeModalRef.current?.click()
                    const dataTemplate = multiMeetings.find(item => item.id === event?.meeting?.templateId)
                    setSelectMultiMeeting(dataTemplate!)
                    setDataMeeting(response.data.data)
                    setShowDetailMeetingModal(true)
                }
            } catch (error: any) {
                Swal.fire({
                    target: document.getElementById('detail-event-modal'),
                    icon: 'error',
                    title: error.response.data.message,
                    confirmButtonText: 'Ok',
                    heightAuto: false,
                })
            }
        }
    }

    const handleClickDetailPipeline = async () => {
        if (event?.lead) {
            try {
                const response = await getDetailPipeline(event?.lead.id, token)
                if (response.data.success) {
                    closeModalRef.current?.click()
                    const dataTemplate = multiPipelines.find(item => item.id === event?.lead?.templateId)
                    setSelectMultiPipeline(dataTemplate!)
                    setDataPipeline(response.data.data)
                    setShowDetailPipelineModal(true)
                }
            } catch (error: any) {
                Swal.fire({
                    target: document.getElementById('detail-event-modal'),
                    icon: 'error',
                    title: error.response.data.message,
                    confirmButtonText: 'Ok',
                    heightAuto: false,
                })
            }
        }
    }

    return (
        <>
            <div className={`modal fade ${(showDeleteModal || showUpdateModal) ? "d-none" : "show"}`} tabIndex={-1} id={`detail-event-modal`} style={{ zIndex: "9999" }} ref={modalRef}>
                <div className="modal-dialog modal-dialog-centered" style={{ minHeight: "100%", maxWidth: "650px" }}>
                    {
                        eventDetailError ?
                            <div className="modal-content">
                                <div className='m-10 alert alert-danger'>
                                    <div className='alert-text font-weight-bold'>{intl.formatMessage({ id: 'FORM.LABEL.ERROR' })}</div>
                                </div>
                            </div>
                            :
                            <div className="modal-content">
                                <div className="modal-header border-0 justify-content-end">
                                    {
                                        event?.type === "OTHER" && accessEvent !== "READER" && event?.isOrganizer &&
                                        <>
                                            <div className="btn btn-icon btn-sm btn-color-gray-400 btn-active-icon-primary me-2" onClick={() => { setShowUpdateModal(true) }}>
                                                <span className="svg-icon svg-icon-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="black"></path>
                                                        <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="black"></path>
                                                    </svg>
                                                </span>
                                            </div>
                                            <div className="btn btn-icon btn-sm btn-color-gray-400 btn-active-icon-danger me-2" onClick={() => { handleDeleteEvent(event) }}>
                                                <span className="svg-icon svg-icon-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="black"></path>
                                                        <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="black"></path>
                                                        <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="black"></path>
                                                    </svg>
                                                </span>
                                            </div>
                                        </>
                                    }
                                    <div className="btn btn-icon btn-sm btn-color-gray-500 btn-active-icon-primary" data-bs-dismiss="modal" ref={closeModalRef}>
                                        <span className="svg-icon svg-icon-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect>
                                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                                {
                                    eventDetailValidating ?
                                        <div className="modal-body pt-0 pb-10 px-lg-17" style={{ height: "100px" }}>
                                            <div className="loading-overlay">
                                                <div className="loader"></div>
                                            </div>
                                        </div>
                                        :
                                        <div className="modal-body pt-0 pb-10 px-lg-17">
                                            <div className="mb-9">
                                                <div className="d-flex align-items-center mb-2">
                                                    {
                                                        (event?.type === "MEETING") ? <span className="fs-3 fw-bolder me-3 text-primary cursor-pointer" onClick={handleClickDetailMeeting}>{event?.title} <KTSVG path="/media/icons/duotune/arrows/arr095.svg" className='svg-icon-5 svg-icon-primary' /></span>
                                                            : (event?.type === "PIPELINE") ? <span className="fs-3 fw-bolder me-3 text-primary cursor-pointer" onClick={handleClickDetailPipeline}>{event?.title} <KTSVG path="/media/icons/duotune/arrows/arr095.svg" className='svg-icon-5 svg-icon-primary' /></span>
                                                                : <span className="fs-3 fw-bolder me-3">{event?.title}</span>
                                                    }
                                                    {
                                                        event?.allDay &&
                                                        <span className="badge badge-light-success">{intl.formatMessage({ id: 'FORM.LABEL.ALL_DAY' })}</span>
                                                    }
                                                </div>
                                                {
                                                    event?.allDay ?
                                                        (moment(event?.end).subtract(1, 'days').local().format("DD MMMM YYYY") === moment(event?.start).local().format("DD MMMM YYYY")) ?
                                                            <span className="fs-6">{moment(event?.start).local().format("DD MMMM YYYY")}</span>
                                                            : <span className="fs-6">{moment(event?.start).local().format("DD MMMM YYYY")} - {moment(event?.end).subtract(1, 'days').local().format("DD MMMM YYYY")}</span>
                                                        : <span className="fs-6">{moment(event?.start).local().format("DD MMMM YYYY")} · {moment(event?.start).local().format("HH:mm")} - {moment(event?.end).subtract(1, 'days').local().format("HH:mm")}</span>
                                                }
                                                <div className="fs-6">{event?.description}</div>
                                            </div>

                                            {
                                                event !== undefined && event?.allAttendance.length > 0 &&
                                                <div className="mb-3">
                                                    <div className="d-flex">
                                                        <span className="svg-icon svg-icon-1 svg-icon-muted me-5">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z" fill="black" />
                                                                <rect opacity="0.3" x="8" y="3" width="8" height="8" rx="4" fill="black" />
                                                            </svg>
                                                        </span>
                                                        <div className="d-flex align-items-center collapsible toggle mb-0 collapsed text-hover-primary cursor-pointer" data-bs-toggle="collapse" data-bs-target="#kt_color" aria-expanded="true">
                                                            <div className="d-flex align-items-center flex-wrap">
                                                                <div className='fs-5'>{event?.allAttendance.length} {intl.formatMessage({ id: 'FORM.LABEL.PARTICIPANT' })}</div>
                                                            </div>
                                                            <div className="ms-1">
                                                                <span className="svg-icon toggle-on svg-icon-primary svg-icon-2">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                        <path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="black"></path>
                                                                    </svg>
                                                                </span>
                                                                <span className="svg-icon toggle-off svg-icon-2">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                        <path d="M12.6343 12.5657L8.45001 16.75C8.0358 17.1642 8.0358 17.8358 8.45001 18.25C8.86423 18.6642 9.5358 18.6642 9.95001 18.25L15.4929 12.7071C15.8834 12.3166 15.8834 11.6834 15.4929 11.2929L9.95001 5.75C9.5358 5.33579 8.86423 5.33579 8.45001 5.75C8.0358 6.16421 8.0358 6.83579 8.45001 7.25L12.6343 11.4343C12.9467 11.7467 12.9467 12.2533 12.6343 12.5657Z" fill="black"></path>
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id="kt_color" className="fs-5 ms-10 collapse">
                                                        <ul>
                                                            {event?.allAttendance.map((item) => (
                                                                <li className="fs-5">
                                                                    {item.name}
                                                                    {
                                                                        item.response === "ACCEPTED" ? <KTSVG path={'/media/icons/duotune/general/gen043.svg'} className='svg-icon-2 ms-2 svg-icon-success' />
                                                                            : item.response === "TENTATIVE" ? <KTSVG path={'/media/icons/duotune/general/gen046.svg'} className='svg-icon-2 ms-2' />
                                                                                : item.response === "DECLINED" ? <KTSVG path={'/media/icons/duotune/general/gen040.svg'} className='svg-icon-2 ms-2 svg-icon-danger' />
                                                                                    : <></>
                                                                    }
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            }

                                            {
                                                (event?.leadReminderTime || event?.reminderMinutes) &&
                                                <div className="d-flex align-items-baseline mb-3">
                                                    <span className="svg-icon svg-icon-1 svg-icon-muted me-5">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path opacity="0.3" d="M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z" fill="black" />
                                                            <path d="M19 15V18C19 18.6 18.6 19 18 19H6C5.4 19 5 18.6 5 18V15C6.1 15 7 14.1 7 13V10C7 7.6 8.7 5.6 11 5.1V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V5.1C15.3 5.6 17 7.6 17 10V13C17 14.1 17.9 15 19 15ZM11 10C11 9.4 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7C10.3 7 9 8.3 9 10C9 10.6 9.4 11 10 11C10.6 11 11 10.6 11 10Z" fill="black" />
                                                        </svg>
                                                    </span>
                                                    {
                                                        event?.leadReminderTime ?
                                                            <div className="fs-5">{moment(event?.leadReminderTime).local().format("HH:mm")}</div>
                                                            :
                                                            event?.reminderMinutes ?
                                                                <div className="fs-5">{event?.reminderMinutes === 60 ? `1 ${intl.formatMessage({ id: 'HOURS' })}` : event?.reminderMinutes === 1440 ? `24 ${intl.formatMessage({ id: 'HOURS' })}` : `${event?.reminderMinutes} ${intl.formatMessage({ id: 'MINUTES' })}`} {intl.formatMessage({ id: 'FORM.LABEL.EARLIER' })}</div>
                                                                : <></>
                                                    }
                                                </div>
                                            }

                                            {
                                                event?.onlineMeetLink &&
                                                <div className="d-flex align-items-baseline mb-3">
                                                    <span className="svg-icon svg-icon-1 svg-icon-muted me-5">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path opacity="0.3" d="M18.4 5.59998C18.7766 5.9772 18.9881 6.48846 18.9881 7.02148C18.9881 7.55451 18.7766 8.06577 18.4 8.44299L14.843 12C14.466 12.377 13.9547 12.5887 13.4215 12.5887C12.8883 12.5887 12.377 12.377 12 12C11.623 11.623 11.4112 11.1117 11.4112 10.5785C11.4112 10.0453 11.623 9.53399 12 9.15698L15.553 5.604C15.9302 5.22741 16.4415 5.01587 16.9745 5.01587C17.5075 5.01587 18.0188 5.22741 18.396 5.604L18.4 5.59998ZM20.528 3.47205C20.0614 3.00535 19.5074 2.63503 18.8977 2.38245C18.288 2.12987 17.6344 1.99988 16.9745 1.99988C16.3145 1.99988 15.661 2.12987 15.0513 2.38245C14.4416 2.63503 13.8876 3.00535 13.421 3.47205L9.86801 7.02502C9.40136 7.49168 9.03118 8.04568 8.77863 8.6554C8.52608 9.26511 8.39609 9.91855 8.39609 10.5785C8.39609 11.2384 8.52608 11.8919 8.77863 12.5016C9.03118 13.1113 9.40136 13.6653 9.86801 14.132C10.3347 14.5986 10.8886 14.9688 11.4984 15.2213C12.1081 15.4739 12.7616 15.6039 13.4215 15.6039C14.0815 15.6039 14.7349 15.4739 15.3446 15.2213C15.9543 14.9688 16.5084 14.5986 16.975 14.132L20.528 10.579C20.9947 10.1124 21.3649 9.55844 21.6175 8.94873C21.8701 8.33902 22.0001 7.68547 22.0001 7.02551C22.0001 6.36555 21.8701 5.71201 21.6175 5.10229C21.3649 4.49258 20.9947 3.93867 20.528 3.47205Z" fill="black" />
                                                            <path d="M14.132 9.86804C13.6421 9.37931 13.0561 8.99749 12.411 8.74695L12 9.15698C11.6234 9.53421 11.4119 10.0455 11.4119 10.5785C11.4119 11.1115 11.6234 11.6228 12 12C12.3766 12.3772 12.5881 12.8885 12.5881 13.4215C12.5881 13.9545 12.3766 14.4658 12 14.843L8.44699 18.396C8.06999 18.773 7.55868 18.9849 7.02551 18.9849C6.49235 18.9849 5.98101 18.773 5.604 18.396C5.227 18.019 5.0152 17.5077 5.0152 16.9745C5.0152 16.4413 5.227 15.93 5.604 15.553L8.74701 12.411C8.28705 11.233 8.28705 9.92498 8.74701 8.74695C8.10159 8.99737 7.5152 9.37919 7.02499 9.86804L3.47198 13.421C2.52954 14.3635 2.00009 15.6417 2.00009 16.9745C2.00009 18.3073 2.52957 19.5855 3.47202 20.528C4.41446 21.4704 5.69269 21.9999 7.02551 21.9999C8.35833 21.9999 9.63656 21.4704 10.579 20.528L14.132 16.975C14.5987 16.5084 14.9689 15.9544 15.2215 15.3447C15.4741 14.735 15.6041 14.0815 15.6041 13.4215C15.6041 12.7615 15.4741 12.108 15.2215 11.4983C14.9689 10.8886 14.5987 10.3347 14.132 9.86804Z" fill="black" />
                                                        </svg>
                                                    </span>
                                                    <a href={event?.onlineMeetLink} className="fs-5 text-primary" target="_blank" rel="noreferrer">{truncateText(event?.onlineMeetLink, 50)}</a>
                                                </div>
                                            }

                                            <div className="d-flex align-items-baseline mb-3">
                                                <span className="svg-icon svg-icon-1 svg-icon-muted me-5">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="black"></path>
                                                        <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="black"></path>
                                                        <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="black"></path>
                                                    </svg>
                                                </span>
                                                <div className="fs-5">
                                                    {event?.calendar.type === "OTHER"
                                                        ? "[PERSONAL] " + event?.calendar.name
                                                        : "[" + (event?.calendar.type === "PIPELINE" ? settings.pipeline_title : event?.calendar.type === "MEETING" ? settings.meeting_title : event?.calendar.type) + "] " + event?.calendar.name}
                                                </div>
                                            </div>
                                        </div>
                                }
                                {
                                    event !== undefined && event.allAttendance.length > 0 && accessEvent !== "READER" && !eventDetailValidating &&
                                    <>
                                        <hr className="mb-0" />
                                        <div className="d-flex align-items-center justify-content-between px-5 py-3 fs-5">
                                            {intl.formatMessage({ id: 'FORM.LABEL.PRESENT' })} ?
                                            <div>
                                                <button onClick={() => event?.response !== 'ACCEPTED' && handleInvite("ACCEPTED")} className={`btn ${event?.response !== 'ACCEPTED' ? 'btn-white' : 'btn-light-primary'} mx-1`} style={{ padding: "4px 12px", border: `${event?.response !== 'ACCEPTED' ? '1px solid gray' : 'none'}`, borderRadius: "50px" }}>{intl.formatMessage({ id: 'FORM.CONFIRMATION.YES' })}</button>
                                                <button onClick={() => event?.response !== 'DECLINED' && handleInvite("DECLINED")} className={`btn ${event?.response !== 'DECLINED' ? 'btn-white' : 'btn-light-primary'} mx-1`} style={{ padding: "4px 12px", border: `${event?.response !== 'DECLINED' ? '1px solid gray' : 'none'}`, borderRadius: "50px" }}>{intl.formatMessage({ id: 'FORM.CONFIRMATION.NO' })}</button>
                                                <button onClick={() => event?.response !== 'TENTATIVE' && handleInvite("TENTATIVE")} className={`btn ${event?.response !== 'TENTATIVE' ? 'btn-white' : 'btn-light-primary'} mx-1`} style={{ padding: "4px 12px", border: `${event.response !== 'TENTATIVE' ? '1px solid gray' : 'none'}`, borderRadius: "50px" }}>{intl.formatMessage({ id: 'FORM.CONFIRMATION.MAYBE' })}</button>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                    }
                </div>
            </div>
            {
                showUpdateModal && <UpdateEvent eventData={event!} calendarRef={calendarRef} closeModalRefDetail={closeModalRef} listEvent={listEvent} setListEvent={setListEvent} selectedCalendars={selectedCalendars} />
            }
            {
                showDeleteModal && <DeleteEvent eventData={event!} calendarRef={calendarRef} closeModalRefDetail={closeModalRef} listEvent={listEvent} setListEvent={setListEvent} />
            }
        </>
    )
}

export { DetailEvent }